export default "__VITE_ASSET__BG_rg73z__"